import React from 'react'
import Helmet from 'react-helmet'

const HelmetReact = (props) => {
    const {name}=props
    return (
        <>
            <Helmet>
                <title>ONCIO | {name}</title>                
            </Helmet>
        </>
    )
}

export default HelmetReact
